import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthStore } from '@app/core/auth/stores/auth-store';

// Guard that redirects to locked page when session is locked
// Note: Uses lazy injection to avoid circular dependency during app initialization
export const lockedGuard: CanActivateFn = (route, state) => {
  let authStore: AuthStore;
  let router: Router;

  try {
    authStore = inject(AuthStore);
    router = inject(Router);
  } catch (error) {
    // If injection fails during initialization, redirect to login
    const fallbackRouter = inject(Router);
    return fallbackRouter.createUrlTree(['/login'], {
      queryParams: { returnUrl: state.url }
    });
  }

  const authState = authStore.authState();

  if (authState === 'locked') {
    return router.createUrlTree(['/locked'], {
      queryParams: { returnUrl: state.url }
    });
  }

  if (authState === 'unauthenticated') {
    return router.createUrlTree(['/login'], {
      queryParams: { returnUrl: state.url }
    });
  }

  return true;
};
